module.exports = __webpack_public_path__ + "img/image-(2).086e07f7.jpg";